module.exports = __webpack_public_path__ + "img/adt-logo.a7b5f1c8.png";